"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9v6h4l4 3.9961v-14L8 9H4zm10 .1677c.7239.7238 1.1716 1.7238 1.1716 2.8284 0 1.1046-.4477 2.1046-1.1716 2.8284l1.4142 1.4142c1.0858-1.0857 1.7574-2.5857 1.7574-4.2426 0-1.6569-.6716-3.1569-1.7574-4.2426L14 9.1677zm6.1716 2.8284c0 2.4853-1.0074 4.7353-2.6361 6.364l-1.4142-1.4143c1.2668-1.2667 2.0503-3.0167 2.0503-4.9497 0-1.933-.7835-3.683-2.0503-4.9497l1.4142-1.4143c1.6287 1.6287 2.6361 3.8787 2.6361 6.364z"
  })];
};

exports.default = _default;